import React from 'react';

const VersionUpdatePrompt = ({ 
  isVisible, 
  versionInfo, 
  onDismiss, 
  onRefresh 
}) => {
  if (!isVisible || !versionInfo) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <div className="flex items-center mb-4">
          <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">App Updated!</h3>
            <p className="text-sm text-gray-600">Version {versionInfo.current}</p>
          </div>
        </div>

        <div className="mb-6">
          <p className="text-gray-700 mb-2">
            Terriqon has been updated with new features and improvements.
          </p>
          <p className="text-sm text-gray-600">
            Cache has been automatically cleared to ensure optimal performance.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onDismiss}
            className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200"
          >
            Continue
          </button>
          <button
            onClick={onRefresh}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Refresh Now
          </button>
        </div>

        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="text-xs text-gray-500 space-y-1">
            <div>Build: {new Date(versionInfo.buildTime).toLocaleString()}</div>
            <div>Previous: {versionInfo.stored || 'First install'}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionUpdatePrompt;